import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'
import { Modal } from 'react-bootstrap'
import './ModalBody.scss'

interface Props {
  children?: ReactNode
  className?: string
}

export const ModalBody: FC<Props> = ({ children, className }) => (
  <Modal.Body bsPrefix={classNames('modal-dialog-body', className)}>{children}</Modal.Body>
)
